module.exports = __webpack_public_path__ + "img/munic-malvinas.50c0ee94.png";